import { defaultProps } from 'recompose';
import Icon from '@ui/Icon';

const CellIcon = defaultProps({
  size: 20,
})(Icon);

export default CellIcon;



// WEBPACK FOOTER //
// ./src/@ui/TableView/CellIcon.js